/**
 * FlexiPage Theme
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license Commercial
 */
"use strict";
function getAbsolutePos(el) {
    var box = el.getBoundingClientRect();
    var body = document.body;
    var docElem = document.documentElement;
    var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
    var clientTop = docElem.clientTop || body.clientTop || 0;
    var clientLeft = docElem.clientLeft || body.clientLeft || 0;
    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;
    return { top: Math.round(top), left: Math.round(left) };
}
exports.getAbsolutePos = getAbsolutePos;
function scrollToElement(element, duration, offset, callback) {
    if (duration === void 0) { duration = 1000; }
    if (offset === void 0) { offset = 0; }
    if (callback === void 0) { callback = null; }
    var start = document.body.scrollTop || document.documentElement.scrollTop;
    var change = Math.max(0, (getAbsolutePos(element).top + offset)) - start;
    var currentTime = 0;
    var increment = 20;
    var canceled = false;
    //Update duration
    duration = Math.round((Math.abs(change) / 1000) * duration + 500);
    var ease = function (t, b, c, d) { t /= d / 2; if (t < 1)
        return c / 2 * t * t + b; t--; return -c / 2 * (t * (t - 2) - 1) + b; };
    var cancelScroll = function () {
        window.removeEventListener("wheel", cancelScroll);
        window.removeEventListener("keydown", cancelScroll);
        window.removeEventListener("mousewheel", cancelScroll);
        window.removeEventListener("touchstart", cancelScroll);
        canceled = true;
    };
    var animateScroll = function () {
        currentTime += increment;
        var val = ease(currentTime, start, change, duration);
        document.body.scrollTop = val;
        document.documentElement.scrollTop = val;
        if (currentTime < duration && !canceled) {
            setTimeout(animateScroll, increment);
        }
        else {
            if (callback)
                callback();
        }
    };
    window.addEventListener("wheel", cancelScroll);
    window.addEventListener("keydown", cancelScroll);
    window.addEventListener("mousewheel", cancelScroll);
    window.addEventListener("touchstart", cancelScroll);
    animateScroll();
}
exports.scrollToElement = scrollToElement;
(function (HTTP_METHOD) {
    HTTP_METHOD[HTTP_METHOD["GET"] = 0] = "GET";
    HTTP_METHOD[HTTP_METHOD["POST"] = 1] = "POST";
    HTTP_METHOD[HTTP_METHOD["PUT"] = 2] = "PUT";
    HTTP_METHOD[HTTP_METHOD["DELETE"] = 3] = "DELETE";
})(exports.HTTP_METHOD || (exports.HTTP_METHOD = {}));
var HTTP_METHOD = exports.HTTP_METHOD;
function httpRequest(method, path, query, data, cb) {
    //Construct URL
    var url = path;
    if (query) {
        var queryParts = [];
        for (var i in query)
            queryParts.push(encodeURIComponent(i) + "=" + encodeURIComponent(query[i]));
        url += '?' + queryParts.join('&');
    }
    //Set method
    var _method;
    switch (method) {
        case HTTP_METHOD.GET:
            _method = 'GET';
            break;
        case HTTP_METHOD.POST:
            _method = 'POST';
            break;
        case HTTP_METHOD.PUT:
            _method = 'PUT';
            break;
        case HTTP_METHOD.DELETE:
            _method = 'DELETE';
            break;
    }
    //Create request
    var oReq = new XMLHttpRequest();
    oReq.open(_method, url, true);
    //Bind listener
    oReq.addEventListener("load", function () {
        cb(null, oReq.responseText, oReq.status);
    });
    oReq.addEventListener("error", function (ev) {
        cb(ev.error, null, null);
    });
    //Send
    if (data instanceof FormData) {
        oReq.send(data);
    }
    else if (data) {
        oReq.setRequestHeader('Content-type', 'application/json');
        oReq.send(JSON.stringify(data));
    }
    else {
        oReq.send();
    }
}
exports.httpRequest = httpRequest;
function httpMethodFromString(method) {
    switch (method.toUpperCase()) {
        case 'GET': return HTTP_METHOD.GET;
        case 'POST': return HTTP_METHOD.POST;
        case 'PUT': return HTTP_METHOD.PUT;
        case 'DELETE': return HTTP_METHOD.DELETE;
    }
}
exports.httpMethodFromString = httpMethodFromString;
function apiRequest(method, path, query, data, cb) {
    httpRequest(method, path, query, data, function (err, data, status) {
        if (err)
            return cb(err, null, status);
        try {
            var res = JSON.parse(data);
            if (res.error)
                return cb(new Error(res.error), null, status);
            return cb(null, res, status);
        }
        catch (e) {
            return cb(e, null, status);
        }
    });
}
exports.apiRequest = apiRequest;
;



/*****************
 ** WEBPACK FOOTER
 ** ./ts/util.ts
 ** module id = 2
 ** module chunks = 0
 **/